import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/context/AuthContext';
import Landing from '@/pages/Landing';
import ProductDetail from '@/pages/ProductDetail';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import Dashboard from '@/pages/Dashboard';
import AdminDashboard from '@/pages/AdminDashboard';
import PaymentSuccess from '@/pages/PaymentSuccess';
import PaymentCancel from '@/pages/PaymentCancel';
import AuthCallback from '@/pages/AuthCallback';
import VipCheckout from '@/pages/VipCheckout';
import DiscordCallback from '@/pages/DiscordCallback';
import Terms from '@/pages/Terms';
import SeasonalTheme from '@/components/SeasonalTheme';

function AppRouter() {
  const location = useLocation();
  // Detect Emergent OAuth callback in URL fragment synchronously
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/product/:id" element={<ProductDetail />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/checkout/vip" element={<VipCheckout />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/discord/callback" element={<DiscordCallback />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SeasonalTheme />
          <AppRouter />
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: { background: '#181818', color: '#fff', border: '1px solid rgba(255,255,255,0.08)' },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
